import React from "react";
import PropTypes from "prop-types";
import { Button, Form, Icon } from "semantic-ui-react";
import { ArrayField, GroupField, SelectField, TextField } from "react-invenio-forms";
import _get from "lodash/get";
import { i18next } from "@translations/up/i18next";

import { emptyLegalEntity } from "./initialValues";

export const LegalRelatedEntityField = ({ fieldPath, options }) => {
  return (
    <ArrayField
      addButtonLabel={i18next.t("Add entities")}
      defaultNewValue={emptyLegalEntity}
      fieldPath={fieldPath}
    >
      {({ arrayHelpers, indexPath }) => {
        const fieldPathPrefix = `${fieldPath}.${indexPath}`;
        return (
          <GroupField fieldPath={fieldPath} optimized>
            <TextField
              fieldPath={`${fieldPathPrefix}.name`}
              label={i18next.t("Name")}
              required
              width={8}
            />
            <SelectField
              fieldPath={`${fieldPathPrefix}.type`}
              label={i18next.t("Type")}
              optimized
              options={options}
              required
              width={8}
            />
            <Form.Field>
              <Button
                aria-label={i18next.t("Remove field")}
                className="close-btn"
                icon
                onClick={() => arrayHelpers.remove(indexPath)}
              >
                <Icon name="close" />
              </Button>
            </Form.Field>
          </GroupField>
        );
      }}
    </ArrayField>
  );
};

LegalRelatedEntityField.propTypes = {
  fieldPath: PropTypes.string.isRequired,
  options: PropTypes.array,
};

LegalRelatedEntityField.defaultProps = {
  options: [],
};
